export default __webpack_public_path__ + "static/media/image1.00510d55.jpg";